import {
  type AvailabilityContextValue,
  useAvailabilityContext,
} from '@/contexts/AvailabilityContext';

/**
 * Hook to access user availability status.
 *
 * Delegates to the app-wide AvailabilityProvider context which manages
 * fetching, heartbeat, and login/logout transitions.
 */
export const useAvailability = (): AvailabilityContextValue => useAvailabilityContext();
